import type { TransformNode } from '@babylonjs/core';

import type { BoundingBox, Sphere } from './loading-v2/OctreeGeometry';
import type { OctreeGeometryNode } from './loading-v2/OctreeGeometryNode';
import type { SimplePointsCloudSystem } from './simple-point-cloud-system';
import type { IPointCloudTreeNode } from './types';

export class PointCloudOctreeNode implements IPointCloudTreeNode {
  geometryNode: OctreeGeometryNode;

  sceneNode: SimplePointsCloudSystem;

  pcIndex: number | undefined = undefined;

  boundingBoxNode: TransformNode | null = null;

  readonly children: (IPointCloudTreeNode | null)[];

  readonly loaded = true;

  readonly isTreeNode: boolean = true;

  readonly isGeometryNode: boolean = false;

  constructor(
    geometryNode: OctreeGeometryNode,
    sceneNode: SimplePointsCloudSystem,
  ) {
    this.geometryNode = geometryNode;
    this.sceneNode = sceneNode;
    this.children = geometryNode.children.slice();
  }

  dispose(): void {
    this.geometryNode.dispose();
  }

  disposeSceneNode(): void {
    this.sceneNode.dispose();
  }

  traverse(
    cb: (node: IPointCloudTreeNode) => void,
    includeSelf?: boolean,
  ): void {
    this.geometryNode.traverse(cb, includeSelf);
  }

  get id() {
    return this.geometryNode.id;
  }

  get name() {
    return this.geometryNode.name;
  }

  get level(): number {
    return this.geometryNode.level;
  }

  get isLeafNode(): boolean {
    return this.geometryNode.isLeafNode;
  }

  get numPoints(): number {
    return this.geometryNode.numPoints;
  }

  get index() {
    return this.geometryNode.index;
  }

  get boundingSphere(): Sphere {
    return this.geometryNode.boundingSphere;
  }

  get boundingBox(): BoundingBox {
    return this.geometryNode.boundingBox;
  }

  get spacing() {
    return this.geometryNode.spacing;
  }
}
